import React from 'react'
import * as Sentry from '@sentry/browser'
import { withTranslation } from 'react-i18next'

import Button from 'app/components/ButtonDefault'
import './styles.scss'
const baseClass = 'component-error'

const ComponentError = ({ t }) => (
  <div className={baseClass}>
    <div className={`${baseClass}__content`}>
      <div className={`${baseClass}__text`}>{t('Oops, something went wrong!')}</div>
      <div className={`${baseClass}__promise`}>{t('Our team is already notified and we will fix this ASAP')}</div>
      <div className={`${baseClass}__buttons`}>
        <Button
          remove
          onClick={() => Sentry.lastEventId() && Sentry.showReportDialog()}
          className={`${baseClass}__report`}
        >
          {t('Submit this Error')}
        </Button>
        <a href="/" className={`${baseClass}__go-back`}>
          {t('Go back')}
        </a>
      </div>
    </div>
  </div>
)

export default withTranslation()(ComponentError)
